import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-317f42dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters" }
const _hoisted_2 = {
  key: 0,
  class: "tools"
}
const _hoisted_3 = { class: "albums" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang play" })
], -1))
const _hoisted_6 = { class: "tip" }
const _hoisted_7 = { class: "del" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "not-found c-thirdary"
}
const _hoisted_10 = { class: "shorts" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mask" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang play" })
], -1))
const _hoisted_15 = { class: "tip" }
const _hoisted_16 = { class: "del" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "not-found c-thirdary"
}
const _hoisted_19 = {
  key: 3,
  class: "articles"
}
const _hoisted_20 = ["onClick"]

import device from '@/store/device';
import favorites, { State } from '@/store/mine/favorites';
import * as links from '@/views/links';
import { computed, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Album from '../../movies/albums/Album.vue';
import i18, { State as I18State } from '@/store/i18';
import * as filters from '@/views/filters';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const router = useRouter()
const data = computed<State>(() => store.state[favorites.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].mineText)
const temp = reactive({
    type: 'movie',
})
onMounted(() => {
    favorites.loadList(store)
})

function onType(value: string) {
    temp.type = value
    if (value == 'movie') {
        favorites.loadList(store)
    } else if (value == 'short') {
        favorites.loadShort(store)
    } else if (value == 'article') {
        favorites.loadArticles(store)
    }
}

function onGo(item: Favorite) {
    if (item.channel_id > 0) {
        router.push({
            name: 'channel-movies',
            params: { id: item.movid }
        })
    } else {
        router.push(links.album(item.movid))
    }
}

async function onRemove(item: Favorite, i: number) {
    try {
        await favorites.remove(store, i);
    } catch (e) {
        device.toast(store, lang.value.errorDelete)
    }
}

async function onClear() {
    try {
        await favorites.clear(store);
    } catch (e) {
        device.toast(store, lang.value.errorClear)
    }
}

async function onRemoveShort(id: number) {
    try {
        await favorites.removeShort(store, id)
    } catch (e) {
        device.toast(store, lang.value.errorDelete)
    }
}

function onPlayShort(id: number) {
    router.push({
        name: 'channel-short',
        query: {
            id
        }
    })
}
function onOpenArticle(id: number) {
    router.push({
        name: 'article-detail-view',
        params: {
            id: id
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("b", null, _toDisplayString(_unref(lang).favoriteTypes), 1),
      _createElementVNode("div", null, [
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(temp).type == 'movie' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onType('movie')))
        }, _toDisplayString(_unref(lang).favoriteMovie), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(temp).type == 'short' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onType('short')))
        }, _toDisplayString(_unref(lang).favoriteShort), 3),
        _createElementVNode("a", {
          class: _normalizeClass(["link", { on: _unref(temp).type == 'article' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (onType('article')))
        }, _toDisplayString(_unref(lang).favoriteArticle), 3)
      ])
    ]),
    (_unref(data).list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(temp).type == 'movie')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "album-item",
                key: i
              }, [
                _createVNode(Album, {
                  album: item.movie
                }, null, 8, ["album"]),
                _createElementVNode("div", {
                  class: "mask",
                  onClick: ($event: any) => (onGo(item))
                }, [
                  _hoisted_5,
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(lang).play), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (onRemove(item, i)), ["stop"])
                    }, _toDisplayString(_unref(lang).delete), 9, _hoisted_8)
                  ])
                ], 8, _hoisted_4)
              ]))
            }), 128))
          ]),
          (_unref(data).list.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(lang).empty), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(temp).type == 'short')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).shorts, (item) => {
              return (_openBlock(), _createElementBlock("a", {
                class: "short-item",
                style: _normalizeStyle(_unref(filters).bg(item.thumb)),
                onClick: ($event: any) => (onPlayShort(item.id))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(item.title), 1),
                  _hoisted_14,
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(lang).play), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (onRemoveShort(item.id)), ["stop"])
                    }, _toDisplayString(_unref(lang).delete), 9, _hoisted_17)
                  ])
                ])
              ], 12, _hoisted_11))
            }), 256))
          ]),
          (_unref(data).shorts.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(lang).empty), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(temp).type == 'article')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).articles, (item, i) => {
            return (_openBlock(), _createElementBlock("a", {
              class: "article-item",
              onClick: ($event: any) => (onOpenArticle(item.tid))
            }, _toDisplayString(i + 1) + ". " + _toDisplayString(item.title), 9, _hoisted_20))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})